import parser from 'react-html-parser';

import markdownIt from 'markdown-it';

const markdownItOptions = {
  html: true,
  breaks: true,
  linkify: true,
  typographer: true,
};

/**
 * Converts a Markdown string to one or more React elements
 * @param {string} markdown
 * @param {boolean} [allowHtml=false] - whether to allow HTML in source content
 * @param {string} [strip=false] - whether to strip a tag from the output
 * @return {HTMLElement}
 */
export const markdownToReactElement = (markdown: string, allowHtml = true) => {
  markdownItOptions.html = allowHtml;

  const html = markdownIt(markdownItOptions).renderInline(markdown);

  return parser(html);
};

const SQUARE_PRESETS = [48, 64, 128, 256, 512, 1024, 2048] as const;

// Returns the smallest square preset that covers targetWidth, or the largest as fallback.
const squarePresetFor = (targetWidth: number): string => {
  const match = SQUARE_PRESETS.find((s) => s >= targetWidth);
  return `square-${match ?? 2048}`;
};

// Convert a CMS image URL (imgdrop.imgix.net or already-migrated images.opendoor.com)
// to a CDN URL sized via the nearest square preset.
export const resizeImageUrl = (url: string, targetWidth: number): string => {
  const preset = squarePresetFor(targetWidth);
  try {
    const parsed = new URL(url);
    if (parsed.hostname === 'imgdrop.imgix.net') {
      const path = parsed.pathname.replace(/^\//, '');
      return `https://images.opendoor.com/source/s3/imgdrop-production/${path}?service=cosmos&preset=${preset}`;
    }
    if (parsed.hostname === 'images.opendoor.com') {
      parsed.searchParams.set('service', 'cosmos');
      parsed.searchParams.set('preset', preset);
      return parsed.toString();
    }
    return url;
  } catch {
    return url;
  }
};

export const contentfulToImagesWorkerUrl = (contentfulURL: string): string => {
  const normalized = contentfulURL.startsWith('//') ? `https:${contentfulURL}` : contentfulURL;
  const { pathname } = new URL(normalized);
  return `https://images.opendoor.com/source/contentful${pathname}`;
};
